import { DATE_TIME_YMD } from '@/shared/components/constants/common.constants';
import { formatDateTime } from '@/shared/utils/datetime';
import Heading from '@shared/components/common/Heading';
import { ORDER_STATUS_COLORS, ORDER_STATUS_LABELS } from '@shared/components/constants/select.constant';
import { OrderDetail } from '@shared/types/order';
import { cn, formatPrice } from '@shared/utils/utils';

interface PaymentInfoProps {
    order: OrderDetail
}

export default function PaymentInfo({ order }: PaymentInfoProps) {
    const paymentInfo = [
        {
            label: '税別支払金額',
            value: formatPrice(order.preAmount || 0)
        },
        {
            label: '消費税（10%）',
            value: formatPrice(order.tax || 0)
        },
        {
            label: '支払い金額',
            value: formatPrice(order.totalAmount || 0)
        },
        {
            label: '支払い方法',
            value: order.paymentMethod || '-'
        }
    ];

    return (
        <div className='bg-white rounded-lg shadow p-4 md:p-6'>

            {/* Payment Information */}
            <div className='space-y-4'>
                <Heading variant='h6' as='h3'>支払い情報</Heading>
                <ul className='space-y-4'>
                    {paymentInfo.map(info => (
                        <li key={info.label} className='flex justify-between text-sm'>
                            <span className='text-text-secondary'>{info.label}</span>
                            <span className='font-medium'>{info.value}</span>
                        </li>
                    ))}
                </ul>
            </div>

            <hr className='my-4' />
            {/* Payment History */}
            <div className='space-y-4'>
                <Heading variant='h6' as='h3'>取引履歴</Heading>
                <ul className={cn('p-3 border rounded', order.orderPayments?.length ? '' : 'hidden')}>

                    {order.orderPayments?.map(orderItem => (
                        <li key={orderItem.id} className='justify-between text-sm grid grid-cols-2 md:grid-cols-4 gap-3 p-3 odd:bg-gray-100'>
                            <div className='flex flex-col gap-2.5'>
                                <span className='text-text-secondary'>作成日</span>
                                <span className='font-medium'>{formatDateTime(orderItem.createdAt, DATE_TIME_YMD)}</span>
                            </div>

                            <div className='flex flex-col gap-2.5'>
                                <span className='text-text-secondary'>支払日</span>
                                <span className='font-medium'>{formatDateTime(orderItem.orderAt, DATE_TIME_YMD)}</span>
                            </div>

                            <div className='flex flex-col gap-2.5'>
                                <span className='text-text-secondary'>金額</span>
                                <span className='font-medium'>{formatPrice(orderItem.totalAmount || 0)}</span>
                            </div>

                            <div className='flex flex-col gap-2.5'>
                                <span className='text-text-secondary'>ステータス</span>
                                <span className={cn('w-fit px-3 py-1 font-medium rounded-full text-sm', ORDER_STATUS_COLORS[orderItem.status])}>
                                    {ORDER_STATUS_LABELS[orderItem.status]}
                                </span>
                            </div>
                        </li>
                    ))}

                </ul>
            </div>
        </div>
    );
}
